module.exports = __webpack_public_path__ + "static/media/gt.ed4b7f77.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gt.svg
// module id = 2105
// module chunks = 0